module.exports = __webpack_public_path__ + "img/teddy.b44f9210.svg";